import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded'
import LoginIcon from '@mui/icons-material/Login';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';


export default function ContactsList( { handleAuthAction, handleDrawerClose } ) {


  const navigate = useNavigate();


  const mainListItems = [
    { name: 'Tomek Woźniak', iconUrl: 'https://jakiesfoto' },
    { name: 'Kasia Kowalska', iconUrl: 'https://jakiesfoto' },
    { name: 'Ania Nowak', iconUrl: 'https://jakiesfoto' },
    { name: 'Tomek Woźniak', iconUrl: 'https://jakiesfoto' },
    { name: 'Kasia Kowalska', iconUrl: 'https://jakiesfoto' },
    { name: 'Ania Nowak', iconUrl: 'https://jakiesfoto' },
    { name: 'Tomek Woźniak', iconUrl: 'https://jakiesfoto' },
    { name: 'Kasia Kowalska', iconUrl: 'https://jakiesfoto' },
    { name: 'Ania Nowak', iconUrl: 'https://jakiesfoto' },
    { name: 'Tomek Woźniak', iconUrl: 'https://jakiesfoto' },
    { name: 'Kasia Kowalska', iconUrl: 'https://jakiesfoto' },
    { name: 'Ania Nowak', iconUrl: 'https://jakiesfoto' },
    { name: 'Tomek Woźniak', iconUrl: 'https://jakiesfoto' },
    { name: 'Kasia Kowalska', iconUrl: 'https://jakiesfoto' },
    { name: 'Ania Nowak', iconUrl: 'https://jakiesfoto' },
    // { text: 'Analytics', icon: <AnalyticsRoundedIcon /> },
    // { text: 'Clients', icon: <PeopleRoundedIcon /> },
    // { text: 'Tasks', icon: <AssignmentRoundedIcon /> },
  ];
  
  const secondaryListItems = [
    
    { text: 'Settings', icon: <SettingsRoundedIcon /> },
    { text: 'About', icon: <InfoRoundedIcon /> },
    { text: 'Feedback', icon: <HelpRoundedIcon /> },
  ];


  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton selected={index === 0}>
                <Stack direction="row"
                    sx={{
                        p: 2,
                        gap: 3,
                        alignItems: 'center',
                        borderTop: '1px solid',
                        borderColor: 'divider',
                        // marginLeft: '5px',
                    }}>
                    <Avatar
                        // onClick={handleDrawerToggle}
                        sizes="small"
                        alt={item.name}
                        src="/static/images/avatar/7.jpg"
                        sx={{ width: 40, height: 40}}
                    />
                        <Typography variant="body2" sx={{ color: 'white', fontWeight: 500, lineHeight: '16px' }}>
                            {item.name}
                        </Typography>                
                </Stack>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}